export default __webpack_public_path__ + "static/hiit_it_interval_timer_mac-move@2x-a8f14bfeb4e92192c3a0fab06e9b41f7.webp";